<template>
  <a-tabs v-model:activeKey="activeKey" @tabClick="tabClick">
    <a-tab-pane :key="-1" tab="全部"> </a-tab-pane>
    <a-tab-pane
      v-for="(item, index) in configList"
      :key="item.type"
      :tab="item.appName"
      :disabled="loading"
    >
    </a-tab-pane>
  </a-tabs>
  <XATable
    :columns="columns"
    :dataSource="tableData"
    :scroll="{ x: 1500 }"
    :loading="loading"
  >
    <template #coverRate="{ scope }">
      <span>{{ scope.record.coverRate.toFixed(2) }}%</span>
    </template>
    <template #showRate="{ scope }">
      <span>{{ scope.record.showRate.toFixed(2) }}%</span>
    </template>

    <template #estimatedEarnings="{ scope }">
      <span>${{ scope.record.estimatedEarnings.toFixed(2) }}</span>
    </template>
    <template #observedEcpm="{ scope }">
      <span>${{ scope.record.observedEcpm.toFixed(2) }}</span>
    </template>
    <template #ctr="{ scope }">
      <span>{{ scope.record.ctr.toFixed(2) }}</span>
    </template>
    <template #matchRate="{ scope }">
      <span>{{ scope.record.matchRate.toFixed(2) }}%</span>
    </template>
    <template #cpc="{ scope }">
      <span>{{ toFixedDown(scope.record.cpc, 3) }}</span>
    </template>
    <template #income="{ scope }">
      <span>${{ toFixedDown(scope.record.income, 2) }}</span>
    </template>
    <template #pageRpm="{ scope }">
      <span>{{ toFixedDown(scope.record.pageRpm, 2) }}</span>
    </template>
    <template #control="{ scope }">
      <a-button
        v-if="tableData.indexOf(scope.record) !== 0"
        type="link"
        @click="confirmDetail(scope.record)"
        >详情</a-button
      >
    </template>
    <!-- <template #type="{ scope }">
      <span>
        {{
          scope.record.type === 1
            ? "火山开发者"
            : scope.record.type === 2
            ? "玫瑰开发者"
            : ""
        }}
      </span>
    </template> -->
  </XATable>
  <!-- <div class="pagination">
        <a-pagination :current="pageNo" :total="total" :pageSize="pageSize" @change="pageChange"
            :showSizeChanger="false"></a-pagination>
    </div> -->
  <XDialog
    :visible="detailVisible"
    :title="adsTitle"
    xWidth="100%"
    @cancel="detailVisible = false"
  >
    <XATable
      :columns="detailColumns"
      :dataSource="detailTableData"
      :scroll="{ x: 1500 }"
      :loading="detailLoading"
    >
      <template #coverRate="{ scope }">
        <span>{{ scope.record.coverRate.toFixed(2) }}%</span>
      </template>
      <template #showRate="{ scope }">
        <span>{{ scope.record.showRate.toFixed(2) }}%</span>
      </template>

      <template #estimatedEarnings="{ scope }">
        <span>${{ scope.record.estimatedEarnings.toFixed(2) }}</span>
      </template>
      <template #observedEcpm="{ scope }">
        <span>${{ scope.record.observedEcpm.toFixed(2) }}</span>
      </template>
      <template #ctr="{ scope }">
        <span>{{ scope.record.ctr.toFixed(2) }}</span>
      </template>
      <template #matchRate="{ scope }">
        <span>{{ scope.record.matchRate.toFixed(2) }}%</span>
      </template>
      <template #cpc="{ scope }">
        <span>{{ toFixedDown(scope.record.cpc, 3) }}</span>
      </template>
      <template #income="{ scope }">
        <span>${{ toFixedDown(scope.record.income, 2) }}</span>
      </template>
      <template #pageRpm="{ scope }">
        <span>{{ toFixedDown(scope.record.pageRpm, 2) }}</span>
      </template>
    </XATable>
  </XDialog>
</template>

<script lang="ts" setup>
import Vue, {
  onMounted,
  ref,
  watch,
  defineAsyncComponent,
  onBeforeUnmount,
  computed,
} from "vue";
import {
  admDateList,
  configAdmList,
  admDateListAdUnit,
  h5AdmDateList,
  h5AdmDateListAdUnit,
} from "@/api/api";
const XATable = defineAsyncComponent(() => import("../components/XATable.vue"));
import XDialog from "@/components/XDialog.vue";
import { notification } from "ant-design-vue";
import { onBeforeRouteLeave } from "vue-router";
import { useStore } from "vuex";
const store = useStore();
import dayjs, { Dayjs } from "dayjs";

const props = defineProps<{
  appData: any;
  dateTime: any;
  //   isConsume: boolean;
  isRefresh: boolean;
  dbName: String;
}>();
const currentAppId = ref("");
const rightAppIdVal = ref<any[]>([]);
var appIdList: any[] = [];
const maxTagCount = ref(1);
const checkedValue = ref(true);
const configList = ref([
  { type: 1, appName: "火山开发者" },
  { type: 2, appName: "玫瑰开发者" },
]);
const dateValue = ref("");
const pageNo = ref(1);
const activeKey = ref(-1);
const detailVisible = ref(false);
const detailLoading = ref(false);
const adsTitle = ref("详情");
const curDetailRow = ref<any>({});

const columns = ref([
  { title: "Date", key: "day", dataIndex: "day" },
  //   { title: "ID", key: "id", dataIndex: "id" },
  //   { title: "Remark", key: "scene", dataIndex: "scene" },
  { title: "*Page View", key: "pageView", dataIndex: "pageView" },
  {
    title: "*Page RPM",
    key: "pageRpm",
    dataIndex: "pageRpm",
    slots: { customRender: "pageRpm" },
  },
  { title: "Request", key: "adRequest", dataIndex: "adRequest" },
  { title: "Show", key: "adShowCount", dataIndex: "adShowCount" },
  { title: "Clicks", key: "adClickCount", dataIndex: "adClickCount" },
  {
    title: "Match Rate",
    key: "coverRate",
    dataIndex: "coverRate",
    slots: { customRender: "coverRate" },
  },
  {
    title: "Show Rate",
    key: "showRate",
    dataIndex: "showRate",
    slots: { customRender: "showRate" },
  },
  {
    title: "CTR",
    key: "ctr",
    dataIndex: "ctr",
    slots: { customRender: "ctr" },
  },
  {
    title: "CPC",
    key: "cpc",
    dataIndex: "cpc",
    slots: { customRender: "cpc" },
  },
  {
    title: "*Revenue",
    key: "income",
    dataIndex: "income",
    slots: { customRender: "income" },
  },
  {
    title: "控制",
    key: "control",
    dataIndex: "control",
    slots: { customRender: "control" },
  },
]);
const detailColumns = ref([
//   { title: "Date", key: "day", dataIndex: "day" },
  { title: "ID", key: "projectId", dataIndex: "projectId" },
  { title: "*Page View", key: "pageView", dataIndex: "pageView" },
  {
    title: "*Page RPM",
    key: "pageRpm",
    dataIndex: "pageRpm",
    slots: { customRender: "pageRpm" },
  },
  { title: "Request", key: "adRequest", dataIndex: "adRequest" },
  { title: "Show", key: "adShowCount", dataIndex: "adShowCount" },
  { title: "Clicks", key: "adClickCount", dataIndex: "adClickCount" },
  {
    title: "Match Rate",
    key: "coverRate",
    dataIndex: "coverRate",
    slots: { customRender: "coverRate" },
  },
  {
    title: "Show Rate",
    key: "showRate",
    dataIndex: "showRate",
    slots: { customRender: "showRate" },
  },
  {
    title: "CTR",
    key: "ctr",
    dataIndex: "ctr",
    slots: { customRender: "ctr" },
  },
  {
    title: "CPC",
    key: "cpc",
    dataIndex: "cpc",
    slots: { customRender: "cpc" },
  },
  {
    title: "*Revenue",
    key: "income",
    dataIndex: "income",
    slots: { customRender: "income" },
  },
  { title: "Remark", key: "scene", dataIndex: "scene" },
]);
const tableData = ref([]);
const detailTableData = ref([]);
const loading = ref(false);
let timerInval = ref();
var BackOrderIds: any[] = [];

const getRequestData = () => {
  loading.value = true;
  const params: any = {
    beginTime: dayjs(dateValue.value[0]).format("YYYY-MM-DD"),
    endTime: dayjs(dateValue.value[1]).format("YYYY-MM-DD"),
  };
  if (activeKey.value !== -1) {
    params.type = activeKey.value;
  }
  h5AdmDateList(params).then((res) => {
    loading.value = false;
    res.data.forEach((element: any) => {
      if (!element.date) {
        element.date = "汇总";
      }
    });
    tableData.value = res.data;
  });
};
// 监听 Vuex 的 refreshNeeded 状态
const refreshNeeded = computed(() => store.state.refundRefreshNeeded);

// 监控 refreshNeeded 的变化
watch(refreshNeeded, (newValue) => {
  console.log("123123", newValue);
  if (newValue) {
    // 执行页面刷新操作
    getRequestData();
    // 重置刷新状态
    store.dispatch("resetRefundRefresh");
  }
});

watch(
  () => props.isRefresh,
  (cur, old) => {
    getRequestData();
  }
);

watch(
  () => props.dateTime,
  (cur, old) => {
    console.log(cur);
    dateValue.value = cur;
    getRequestData();
  },
  {
    immediate: true,
  }
);

const tabClick = (tabIndex: any) => {
  activeKey.value = tabIndex;
  getRequestData();
};
const pageChange = (page: any) => {
  pageNo.value = page;
  getRequestData();
};
const getConfigList = () => {
  configAdmList({}).then((res) => {
    console.log(res);
    configList.value = res.data;
  });
};
const confirmDetail = (row: any) => {
  console.log(row);
  curDetailRow.value = row;
  adsTitle.value = "详情" + "(" + row.day + ")";
  detailVisible.value = true;
  detailLoading.value = true;
  var beginTime = row.date;
  var endTime = row.date;
  if (row.date === "汇总") {
    beginTime = dayjs(dateValue.value[0]).format("YYYY-MM-DD");
    endTime = dayjs(dateValue.value[1]).format("YYYY-MM-DD");
  }
  var params = {
    appId: row.appId,
    beginTime: row.day,
    endTime: row.day,
  };
  if (activeKey.value === 1) {
    params.type = 1;
  } else if (activeKey.value === 2) {
    params.type = 2;
  }
  h5AdmDateListAdUnit(params).then((res) => {
    detailLoading.value = false;
    detailTableData.value = res.data;
  });
};
onMounted(() => {
  checkedValue.value = store.state.refundCheckedValue;
  dateValue.value = props.dateTime;
  //   getConfigList();
  getRequestData();
});
const toFixedDown = (num: any, digits: any) => {
  const factor = Math.pow(10, digits);
  return Math.floor(num * factor) / factor;
};
</script>
<style>
.a-tab-pane-content {
  overflow-x: none !important;
}
</style>
